import { Component, ElementRef, Renderer2, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "./components/header/header.component";
import { AuthService } from "../auth/services/auth.service";
import { SideMenuComponent } from "./components/side-menu/side-menu.component";
import { MatIconModule } from "@angular/material/icon";
import { Location } from "@angular/common";
import { ReloadPageComponent } from "../shared/components/reload-page/reload-page.component";
import { ErrorHandlingService } from "../core/error-handler/error-handling.service";
import { ErrorMessage } from "../core/error-handler/errorMessage";
import { NotificationComponent } from "./components/notification/notification.component";
import { TranslateService } from "@ngx-translate/core";
import { LoadingLayoutComponent } from "../shared/components/loading-layout/loading-layout.component";
import { FirebaseService } from "../core/services/firebase.service";
import { UserService } from "@kortobaa-front/authentication";
import { NotificationService } from "./components/notification/notification.service";
import { ImpersonationBannerComponent } from "./components/impersonation-banner/impersonation-banner.component";

@Component({
  selector: "app-layout",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    SideMenuComponent,
    MatIconModule,
    ReloadPageComponent,
    NotificationComponent,
    LoadingLayoutComponent,
    ImpersonationBannerComponent,
  ],
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent {
  sideNavToggleBtn: boolean = JSON.parse(localStorage.getItem("sideNavToggleBtn") || "false");
  /** Breadcrumb segments derived from `location.path()`. Always
   *  starts with 'home' so the breadcrumb root is consistent. */
  route: string[] = [];
  subMenu: boolean = true;
  errorMessage: ErrorMessage | undefined;
  hasUnseenNotification!: number;
  showSideNav: boolean = false;
  @ViewChild("sideNav") sideNav!: ElementRef;
  userLogin = !!this.auth.user.currentUser && !!localStorage.getItem("Token") && !!localStorage.getItem("UserProfile");

  constructor(
    public auth: AuthService,
    private _router: Router,
    location: Location,
    private errorHandlingService: ErrorHandlingService,
    private _firebase: FirebaseService,
    private _user: UserService,
    private _notification: NotificationService,
    private renderer: Renderer2,
    public _translate: TranslateService
  ) {
    this._router.events.subscribe((val) => {
      this.watchTokenValidity();
      if (location.path() != "") {
        this.route = location
          .path()
          .split("/")
          .filter((ele) => {
            return ele != "";
          });
        if (this.route[0] != "home") this.route = ["home", ...this.route];
      }
    });

    // this._user.checkUserValid().subscribe((data: any) => {
    //   if (data) {
    //     this._firebase.requestToken();
    //     this._firebase.listenOnNotification();
    //   }
    // });
    this._notification.getUserIsAuthenticated().subscribe(() => {
      this._firebase.requestToken();
      this._firebase.listenOnNotification();
    });
    // close side nav when click out side in responsive
    this.renderer.listen("window", "click", (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (
        this.sideNav &&
        target &&
        !this.sideNav.nativeElement.children[0].contains(target) &&
        target.id != "sideNavIcon"
      ) {
        this.showSideNav = false;
      }
    });
  }

  async ngOnInit() {
    this.errorHandlingService.errorMessage$.subscribe((message) => {
      this.errorMessage = message;
    });

    try {
      const checkData = await this._user.checkUserValid();
      checkData.subscribe((data: unknown) => {
        if (data) {
          this._firebase.requestToken();
          this._firebase.listenOnNotification();
        }
      });
    } catch (error) {
      // user-validity check failed; ignore — auth guard will redirect
    }
  }

  ngAfterContentChecked() {
    this.userLogin =
      !!this.auth.user.currentUser && !!localStorage.getItem("Token") && !!localStorage.getItem("UserProfile");
  }

  // check token
  watchTokenValidity() {
    let token = localStorage.getItem("Token");
    if (token) {
      const decode = JSON.parse(atob(token.split(".")[1]));
      if (decode.exp * 1000 < new Date().getTime()) {
        this.auth.user.logout();
        localStorage.clear();
        sessionStorage.clear();
        this._router.navigateByUrl("/login");
      }
    }
  }

  // close sub menu when click out side side bar
  toggleSubMenu(e: boolean) {
    this.subMenu = e;
  }

  // toggle Sidebar nav btn and save it to local storage
  toggleSideNav(value: boolean) {
    this.sideNavToggleBtn = value;
    this.subMenu = false;
    localStorage.setItem("sideNavToggleBtn", JSON.stringify(value));
  }
}
